import React from 'react'
import Banner from '../Banner';

const OurNetwork = () => {
  return (
    <div>
      <Banner name={"OurNetwork"} Title={"Our Network"} />
    </div>
  );
}

export default OurNetwork
